export const TITLE = "title"
export const SUB_TITLE = "subTitle"
export const TITLE_DESCRIPTION = "titleDescription"
export const COPYRIGHT = "copyright"
export const HEADER = "header"
export const SUB_HEADER = "subHeader"
export const PARAGRAPH = "paragraph"
export const PAGE_MARGINS = [56, 98, 56, 60]

export const TOC_HEADER = "tocHeader"
export const TOC_HEADER_BASE = {
    tocItem: true,
    tocStyle: TOC_HEADER,
    tocMargin: [0, 5, 0, 0],
}

export const TOC_ITEM = "tocItem"
export const TOC_ITEM_BASE = {
    tocItem: true,
    tocStyle: TOC_ITEM,
}
export const TOC_CC_ITEM_BASE = {
    tocItem: true,
    tocStyle: TOC_ITEM,
    tocMargin: [15, 0, 0, 0],
}

export const LIST = "list"

export const TABLE = "table"
export const TABLE_LAYOUT = {
    hLineWidth: (i: number, node: any) => ((i === 0 || i === 1 || i === node.table.body.length) ? 1 : 0),
    vLineWidth: () => 0,
    paddingLeft: () => 6,
    paddingRight: () => 6,
    paddingTop: () => 6,
    paddingBottom: () => 6,
}
export const TABLE_ARCHITECTURE_LAYOUT = {
    hLineWidth: (i: number, node: any) => ((i === 0 || i === node.table.body.length) ? 1 : 0),
    paddingLeft: () => 12,
    paddingRight: () => 12,
    paddingTop: () => 12,
    paddingBottom: (i: number, node: any) => ((i === node.table.body.length - 1) ? 12 : 0),
}
export const TABLE_ARCHITECTURE_PAGE_LAYOUT = {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
}
export const ITEM_HISTORY_TABLE_LAYOUT = {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingLeft: () => 0,
    paddingRight: () => 0,
    paddingTop: () => 0,
    paddingBottom: () => 0,
}

export const SUBSYSTEM_NAME_MARGIN = [0, 0, 0, 5]
